<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <img src="@/assets/images/pages/not-authorized.png" alt="graphic-not-authorized" class="mx-auto mb-4">
            <template v-if="status === 'loading'">
                <h1 class="sm:mx-0 mx-4 sm:mb-12 mb-8 text-5xl d-theme-heading-color">يرجى الانتظار...</h1>
                <p class="sm:mx-0 mx-4 sm:mb-12 mb-8">يرجى الانتظار ريتما تتم عملية التأكيد</p>
            </template>

          <template v-if="status === 'already_verified'">
            <h1 class="sm:mx-0 mx-4 sm:mb-12 mb-8 text-5xl d-theme-heading-color">تم التفعيل  مسبقا</h1>
            <p class="sm:mx-0 mx-4 sm:mb-12 mb-8 d-theme-text-inverse">لقد تم تفعيل هذا الحساب مسبقا، يرجى الانتظار حتى يتم مراجعة بيانات حسابك من قبل مدير النظام أو قم بتسجيل الدخول في حالة تمت الموافقة مسبقا.</p>
            <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
              <vs-button type="border" to="/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">تسجيل الدخول</vs-button>
            </div>
          </template>

            <template v-if="status === 'error'">
                <h1 class="sm:mx-0 mx-4 sm:mb-12 mb-8 text-5xl d-theme-heading-color">خطأ</h1>
                <p class="sm:mx-0 mx-4 sm:mb-12 mb-8">حدث خطأ في عملية التأكيد</p>
            </template>

            <template v-if="status === 'success'">
                <h1 class="sm:mx-0 mx-4 sm:mb-12 mb-8 text-5xl d-theme-heading-color">تم التأكيد</h1>
                <p class="sm:mx-0 mx-4 sm:mb-12 mb-8"> يرجى الانتظار حتى يتم مراجعة بيانات حسابك من قبل مدير النظام، ستصلك رسالة عندما يتم الموافقة على طلبك. </p>
            </template>


        </div>
    </div>
</template>

<script>

    import authAPI from '@/api/authAPI'

    export default {
        data() {
            return {
                status: 'loading',
                email: this.$route.query.email,
                token: this.$route.query.token,
            }
        },

        methods: {
            verifyEmail() {
                authAPI.verifyEmail(this.email, this.token).then(({data}) => {
                    if(data.message === 'success') {
                        this.status = 'success'
                    } else if (data.message === 'already_verified'){
                        this.status = 'already_verified'
                    } else {
                      this.status = 'error'
                    }

                }).catch(() => this.status = 'error')
            }
        },

        mounted() {
            this.verifyEmail()
        }
    }

</script>
